import { render, staticRenderFns } from "./SpinnerContainer.vue?vue&type=template&id=1130dfa2&scoped=true"
import script from "./SpinnerContainer.vue?vue&type=script&lang=js"
export * from "./SpinnerContainer.vue?vue&type=script&lang=js"
import style0 from "./SpinnerContainer.vue?vue&type=style&index=0&id=1130dfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130dfa2",
  null
  
)

export default component.exports